import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { PatientVitalControllerApi } from "../../services";
import { getConfigObject, useBaseContent } from "../../utils/utils";

interface Props {
  patientUuid: string;
  xTENANTID?: string;
  enabled?: boolean;
}

/**
 *
 * @author atish bagate
 */
export const usePatientLatestVitalsByPatientId = ({
  patientUuid,
  xTENANTID,
  enabled = true,
}: Props): useBaseContent<any> => {
  return useQuery({
    queryKey: ["patient-latest-vitals-by-patient-id", patientUuid, xTENANTID],
    enabled: enabled && !!patientUuid && !!xTENANTID,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    queryFn: async () =>
      await new PatientVitalControllerApi(getConfigObject())
        .getLatestVitalsByPatientId(
          patientUuid,
          xTENANTID // xTENANTID
        )
        .then((res) => res?.data?.data),
  });
};
